<script>

    /**
     * Badge de estatus para usar en el slot "tag" de InfoCard.
     *
     * Props:
     *   label  — texto del tag
     *   color  — color Bulma: "success" | "warning" | "danger" | "info" | "primary" | "dark"
     *   icon   — clase Font Awesome, ej. "fas fa-check-circle"
     */

    export let label = ""
    export let color = "warning"
    export let icon = ""

</script>

<span class="tag is-{ color } is-light is-medium" style="border-radius: 6px;">
    {#if icon}
        <span class="icon is-small mr-1"><i class="{ icon }"></i></span>
    {/if}
    <span>{ label }</span>
</span>
